import {
  createStyles,
  Text,
  SimpleGrid,
  Card,
  Group,
  Button,
  rem,
} from "@mantine/core";
import {
  IconPhone,
  IconBrandWhatsapp,
  IconMail,
  IconMapPin,
  IconBrandFacebook,
} from "@tabler/icons-react";
import { pageTopSpacing } from "../../constant/Responsive";
import SectionHeader from "../layout/SectionHeader";
import PageContainer from "../layout/PageContainer";

const useStyles = createStyles((theme) => ({
  card: {
    border: `1px solid ${theme.colors.gray[2]}`,
    transition: "border-color 0.2s ease",
    height: "100%",
    "&:hover": {
      borderColor: theme.colors.orange[2],
    },
  },
  iconWrap: {
    width: 44,
    height: 44,
    borderRadius: theme.radius.sm,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors.orange[0],
    color: theme.colors.orange[7],
    border: `1px solid ${theme.colors.orange[2]}`,
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[8],
    letterSpacing: "0.04em",
  },
  cardValue: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.gray[7],
    lineHeight: 1.6,
  },
  note: {
    marginTop: theme.spacing.xl,
    padding: theme.spacing.md,
    backgroundColor: theme.colors.gray[0],
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[2]}`,
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[6],
    lineHeight: 1.75,
  },
}));

const contactItems = [
  {
    icon: IconBrandWhatsapp,
    title: "WhatsApp",
    value: "+852 9831 2915",
    href: "https://wa.me/85298312915",
  },
  {
    icon: IconPhone,
    title: "電話",
    value: "+852 9831 2915",
    href: "tel:+85298312915",
  },
  {
    icon: IconMail,
    title: "電郵",
    value: "hangtatmsk@gmail.com",
    href: "mailto:hangtatmsk@gmail.com",
  },
  {
    icon: IconMapPin,
    title: "服務範圍",
    value: "香港全境（部分離島除外）",
  },
  {
    icon: IconBrandFacebook,
    title: "Facebook",
    value: "猫山王朝",
    href: "https://www.facebook.com/pages/category/Food-Wholesaler/%E8%B2%93%E5%B1%B1%E7%8E%8B%E6%9C%9D-387798108690714",
    external: true,
  },
];

export default function ContactUs() {
  const { classes } = useStyles();

  return (
    <PageContainer pt={pageTopSpacing()} pb={rem(48)}>
      <SectionHeader
        order={1}
        title="查詢訂銷"
        subtitle="批發、零售、試板預約 — 歡迎隨時聯絡，我們將盡快回覆。"
      />

      <SimpleGrid cols={3} spacing={20} breakpoints={[{ maxWidth: "md", cols: 2 }, { maxWidth: "sm", cols: 1 }]}>
        {contactItems.map((item) => (
          <Card key={item.title} className={classes.card} shadow="xs" radius="md" p="lg">
            <Group spacing="md" align="flex-start" noWrap>
              <div className={classes.iconWrap}>
                <item.icon size={20} stroke={1.5} />
              </div>
              <div>
                <Text className={classes.cardTitle} mb={4}>
                  {item.title}
                </Text>
                {item.href ? (
                  <Text
                    component="a"
                    href={item.href}
                    target={item.external ? "_blank" : undefined}
                    rel={item.external ? "noopener noreferrer" : undefined}
                    className={classes.cardValue}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {item.value}
                  </Text>
                ) : (
                  <Text className={classes.cardValue}>{item.value}</Text>
                )}
              </div>
            </Group>
          </Card>
        ))}
      </SimpleGrid>

      <Text className={classes.note}>
        急凍產品預約送貨。送貨不包括馬灣、愉景灣、離島區、上樓及停車場費用。（批發價另議）
      </Text>

      <Group position="center" mt="xl">
        <Button
          component="a"
          href="https://wa.me/85298312915"
          target="_blank"
          rel="noopener noreferrer"
          color="orange"
          size="md"
          radius="md"
          leftIcon={<IconBrandWhatsapp size={18} />}
        >
          WhatsApp 即時查詢
        </Button>
      </Group>
    </PageContainer>
  );
}
